<template>
  <span :id="el.id">
    <form
      v-if="customMode"
      v-drag
      class="form p-1 drag-item cursor"
      :style="`background: rgba(255, 255, 255, 0.1); color: ${color}; transform: scale(${el.scale});transform-origin: top left; position: absolute; top:${el.top}; left:${el.left}; z-index:1;height: ${el.height}px;width: ${el.width}px;display: flex;align-items: center;justify-content: center;`"
      @v-drag-end="onDragEnd"
      @click="onFocus"
    >
      <div
        v-if="el.required"
        style="
          color: red;
          height: 26px;
          font-size: 22px;
          position: absolute;
          left: -12px;
          top: 0;
        "
      >
        *
      </div>

      <span :style="{ fontSize: `${el.width * 0.18125}px` }">{{ parsed_name }}</span>
      <button @click.prevent="onRemove" class="cursor p-close">X</button>
    </form>
    <template v-else>
      <span
        v-if="signature"
        class="input-def"
        :id="'form-' + el.id"
        :style="`position: absolute;transform: scale(${el.scale});transform-origin: top left; top:${el.top}; left:${el.left}; z-index:1;height: ${el.height}px;width: ${el.width}px;`"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>
        <img
          :src="signature"
          :alt="el.name"
          :width="`${el.width}px`"
          :height="`${el.height}px`"
        />
      </span>

      <form
        @click="goToSign"
        v-else
        class="form p-1 cursor input-def"
        :id="'form-' + el.id"
        :style="`background: rgba(255, 255, 255, 0.1); color: ${color};transform: scale(${el.scale});transform-origin: top left; position: absolute; top:${el.top}; left:${el.left}; z-index:1;height: ${el.height}px;width: ${el.width}px;display: flex;align-items: center;justify-content: center;`"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>
        <span :style="{ fontSize: `${el.width * 0.18125}px` }"> {{ el.name }} </span>
      </form>
    </template>

    <!-- <span v-else class="cursor"
      :style="`border: 0px; position: absolute; top:${el.top}; left:${el.left}; z-index:99`">
      <img v-if="signature" :src="signature" :alt="el.name" width="100px" />
      <span v-else :style="`color: ${color};`">{{ el.name }}</span>
    </span> -->
  </span>
</template>

<script>
import mixins from "./mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      interval: undefined,
      signature: undefined,
      colors_dict: {
        black: "#000000",
        green: "#008000",
        blue: "#0000ff",
        yellow: "#ffff00",
        purple: "#cd5bcd",
        orange: "#ffa500",
        gray: "#808080",
      },
    };
  },
  props: {
    el: {
      required: true,
    },
  },
  // updated() {
  //   console.log(this.el)
  // },
  computed: {
    parsed_name() {
      return this.el.name !== null &&
        this.el.name !== undefined &&
        typeof this.el.name === "object"
        ? this.el.name.value ?? this.el.name.fieldKey
        : this.el.name;
    },
    color() {
      return this.colors_dict[this.el.color];
    },
  },

  // mounted(){

  // let options = {
  // minWidth: 100, // minimum width in px
  // minHeight: 30, // minimum height in px
  // aspectRatio: false, // if true width height ratio will maintain
  // resizeFromCenter: false, // if true then resize both side from center
  // onDragStart: null, // call-back function that called when dragging start
  // onDragging: null, // call-back function that called every mouse movement till mousedown
  // onDragEnd: null, // call-back function that called when mouse button is released after move
  // onResizeStart: null, // call-back function that called when any resize handler is start dragging
  // onResizing: null, // call-back function that called every mouse movement till musedown
  // onResizeEnd: null, // call-back function that called when release resize handler
  // onRotateStart: null, // call-back function that called when rotate handler is started dragging
  // onRotating: null, // call-back function that called every movement of rotate handler
  // onRotateEnd: null, // call-back function that called when release rotate handler
  // onResizerShown: null, // call-back function that called when resizer is first time shown on target
  // onResizerHide: null, // call-back function that called when resizer is hide on target
  // isHideOnResize: true, // if true then resizer will not visible at the time of dragging so that target visible clearly
  // isHoverLine: true, // if true then target element on mouse hover hoverLine visible for highlight target element
  // resizers: {
  // n: true, // top middle resize handler            true:visible|false:hidden
  // s: true, // bottom middle resize handler
  // e: true, // right middle resize handler
  // w: true, // left middle resize handler
  // ne: true, // top-right resize handler
  // nw: true, // top-left resize handler
  // se: true, // bottom-right resize handler
  // sw: true, // bottom-left resize handler
  // r: true // rotate handler
  // }
  // };

  // document.querySelectorAll('.target').forEach((target) => {
  // resizer.add(target, options);
  // });

  // document.addEventListener("click", (e) => {
  //   resizer.hide();
  // });

  // },

  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    handleResponse({ signature, signature_url }) {
      this.signature = signature;
      this.el.value = signature_url;
    },
    goToSign() {
      let win = window.open(`${this.document.sign_url_part}/${this.el.id}`, "_blank");
      let that = this;
      win.addEventListener(
        "message",
        (event) => {
          console.log(event);
          if (
            event.origin !== window.settings?.common_url ||
            typeof event.data === "string"
          )
            return;
          if (event.data.success) {
            console.log(event.data);
            that.handleResponse(event.data);
          }
        },
        false
      );
    },
  },
};
</script>

<style>
.p-close {
  visibility: hidden;
}

.drag-item:hover .p-close {
  visibility: visible;
}

.p-close {
  background: transparent;
  border: solid 1px;
}
</style>
